<template>
  <section class="home">
        <div class="image">
            <img src="img/nehru-img.jpg" alt="Nehrú Pascoal André Picture">
        </div>
        <div class="content">
            <h3>Hi, i am Nehrú André</h3>
            <span>Software Developer</span>
            <p>
              👋 I am a developer committed to the continuous improvement of my skills to meet the challenges of the technology sector. I seek to join an IT team where I can apply my knowledge in JavaScript, Flutter, MySQL, CSharp and other technologies to develop solutions aligned with the company's needs. I am available for interviews and technical tests and eager to contribute and learn in a new professional environment. Email me at <strong>sonehru@gmail.com</strong>. 
            </p>

            <router-link to="/about" class="btn"> About me <i class="fa fa-user"></i></router-link>
        </div>
    </section>
</template>

<script>

  export default {
    name: 'Home'
  }
</script>

<style scoped>

section {
  padding: 5rem 9%;
}

.btn {
  display: inline-block;
  margin-top: 1rem;
  border-radius: 5rem;
  background: crimson;
  padding: .7rem;
  font-size: 1.7rem;
  color: #fff;
  padding-left: 2rem;
}

.btn i {
  height: 4rem;
  width: 4rem;
  line-height: 4rem;
  font-size: 1.7rem;
  text-align: center;
  background: #fff;
  color: crimson;
  border-radius: 50%;
  margin-left: 1rem;
  transition: .2s linear;
}

.btn:hover i {
  margin-left: 2rem;
}

@media (max-width: 1200px) {
  html {
    font-size: 55%;
  }
  section {
    padding: 3rem 2rem;
  }
}


.home {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4rem;
  min-height: calc(100vh - 6.5rem);
}

.home .image {
  flex: 1 1  42rem;
  text-align: center;
}

.home .image img {
  height: 50rem;
  width: 50rem;
  border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
}

.home .content {
  flex: 1 1 42rem;
}

.home .content h3 {
  color: #fff;
  font-size: 4rem;
  padding-bottom: .5rem;
}

.home .content span {
  font-size: 3rem;
  color: crimson;
  padding: .5rem 0;
  display: block;
}

.home .content p {
  font-size: 1.5rem;
  color: #aaa;
  padding: 1rem 0;
  line-height: 2;
  width: 85%;
}

@media (max-width: 879px) {
  .home {
    text-align: center;
    flex-direction: column;
  }
  .home .content p {
    width: 65%;
    margin: auto;
  }
}

@media (max-width: 768px) {
  .home {
    text-align: center;
    gap: 2rem;
  }
  .home .image img {
    height: 30rem;
    width: 30rem;
  }
  .home .content h3 {
    font-size: 3rem;
  }
  .home .content span {
    font-size: 2.5rem;
  }
}

@media (max-width: 500px) {
  .home .content p {
    width: 80%;
  }
}

</style>
